// extracted by mini-css-extract-plugin
export default {"list":"list-FlO89R","form":"form-s1qWGs","search":"search-UgjNhx"};